"use client";
import { Link } from "@/navigation";
import { useTranslations } from "next-intl";

interface FooterProps {
  /** Links to the guides and the comparison. Off on guest upload pages. */
  hasSiteLinks?: boolean;
}

export default function Footer({ hasSiteLinks = false }: FooterProps) {
  const t = useTranslations("Footer");

  return (
    <div className=" w-full  py-8">
      <div className="p-4  flex flex-col gap-8 mx-auto">
        <hr className=""></hr>
        <div className="flex justify-between gap-4 flex-wrap">
          <p>
            © {new Date().getFullYear()} Guest.Gallery, {t("allRightsReserved")}
          </p>
          <div className="flex flex-col md:flex-row gap-4">
            {hasSiteLinks ? (
              <>
                <Link className="underline" href="/blog">
                  {t("guides")}
                </Link>
                <Link className="underline" href="/sammenligning">
                  {t("comparison")}
                </Link>
              </>
            ) : null}
            <Link className="underline" href="/privacy-policy">
              {t("privacyPolicy")}
            </Link>
            <Link className="underline" href="/terms-and-conditions">
              {t("termsAndConditions")}
            </Link>
            <a
              className="underline"
              href="https://replysky.com"
              target="_blank"
              rel="noreferrer"
            >
              Replysky
            </a>
          </div>
        </div>
      </div>
      <div className="mx-4 text-sm text-gray-500">
        {t("companyLine")}
      </div>
    </div>
  );
}
